import { z } from 'zod';
import { optionalTrimmedNullableString, requiredUuidString } from '../zod-helpers/index.js';
import { CAL_EVENT_CONTACT_CONSTRAINTS } from './constraints.js';
export const updateCalEventContactLinkInputSchema = z.object({
    linkId: requiredUuidString('Contact link is required.', 'Invalid contact link ID.'),
    note: optionalTrimmedNullableString(CAL_EVENT_CONTACT_CONSTRAINTS.note.maxLength, `Note must be ${CAL_EVENT_CONTACT_CONSTRAINTS.note.maxLength} characters or fewer.`),
    followUp: z.boolean().optional(),
});
//# sourceMappingURL=update-cal-event-contact-link-input.js.map